import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import JobCard from "../../Job/JobCard";
import axios from "axios";
import logo from "../../../Assets/employer_logo.png";
import loader from "../../../Assets/giphy.gif"; 

function EmployerDetails() {
  const { id } = useParams();
  const [employerData, setEmployerData] = useState({});
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [wishList, setWishlist] = useState([{}]);
  const userid =localStorage.getItem("userid");

  const getEmployerById = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}companyDetails/bycompanyid/${id}`
      );
      setEmployerData(response.data[0]);
    } catch (error) {
      console.error("Error fetching employer details:", error);
    }
  };

  const getJobsByCompanyId = async (companyId) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}jobs/showjobbycompanyid/${companyId}`
      );
      setJobs(response.data || []);
    } catch (error) {
      console.error("Error fetching jobs:", error);
      setJobs([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchAllWishlistItems = async () => {
    try {
      setLoading(true);
      if(userid){
        const url = `${process.env.REACT_APP_API_URL}job_wishlist/getwishlistbyuserid/${userid}`;
        const response = await axios.get(url);
        setWishlist(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching all jobs:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getEmployerById();
     fetchAllWishlistItems();
  }, [id]);

  useEffect(() => {
    if (employerData.company_id) {
      getJobsByCompanyId(employerData.company_id);
    }
  }, [employerData]);
  const isInWishlist = (job_id) => {
    return wishList.some(wish => wish.job_id === job_id)};

  return (
    <div className="job-area bg-light py-5">
      <div className="container">
        <div className="row">
          <div className="col-lg-4">
            <div className="card mb-4 shadow-sm">
              <div className="card-body">
                <h5 className="mb-4">Employer Overview</h5>
                <div className="row">
                  {/* First Column */}
                  <div className="col-md-6">
                    <div className="mb-3">
                      <h6 className="mb-0">Established</h6>
                    </div>
                    <div className="mb-3">
                      <h6 className="mb-0">Employees</h6>
                    </div>
                    <div className="mb-3">
                      <h6 className="mb-0">Email</h6>
                    </div>
                    <div className="mb-3">
                      <h6 className="mb-0">Website</h6>
                    </div>
                    <div className="mb-3">
                      <h6 className="mb-0">Social Media</h6>
                    </div>
                    <div className="mb-3">
                      <h6 className="mb-0">Location</h6>
                    </div>
                  </div>

                  {/* Second Column */}
                  <div className="col-md-6">
                    <div className="mb-3">
                      <h6 className="mb-0 text-muted">{employerData.established_in}</h6>
                    </div>
                    <div className="mb-3">
                      <h6 className="mb-0 text-muted">{employerData.team_size}</h6>
                    </div>
                    <div className="mb-3">
                      <h6 className="mb-0 text-muted">
                        <a href={`mailto:${employerData.email}`} className="text-decoration-none">
                          {employerData.email}
                        </a>
                      </h6>
                    </div>
                    <div className="mb-3">
                      <h6 className="mb-0 text-muted text-break">
                        <a
                          href={employerData.company_website}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-decoration-none"
                        >
                          {employerData.company_website}
                        </a>
                      </h6>
                    </div>
                    <div className="mb-3">
                      <div className="d-flex">
                        {employerData.linkedin && (
                          <a
                            href={employerData.linkedin}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="me-3 text-primary"
                          >
                            <i className="fab fa-linkedin fa-lg"></i>
                          </a>
                        )}
                        {employerData.facebook && (
                          <a
                            href={employerData.facebook}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="me-3 text-primary"
                          >
                            <i className="fab fa-facebook fa-lg"></i>
                          </a>
                        )}
                        {employerData.twitter && (
                          <a
                            href={employerData.twitter}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="me-3 text-info"
                          >
                            <i className="fab fa-twitter fa-lg"></i>
                          </a>
                        )}
                        {employerData.instagram && (
                          <a
                            href={employerData.instagram}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="me-3 text-danger"
                          >
                            <i className="fab fa-instagram fa-lg"></i>
                          </a>
                        )}
                      </div>
                    </div>
                    <div className="mb-3">
                      <h6 className="mb-0 text-muted">
                        {employerData.address}, {employerData.city}, {employerData.state},{" "}
                        {employerData.country}
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Center Main Card */}
          <div className="col-lg-8">
            <div className="card mb-4 shadow-sm">
            <div className="position-relative">
              <img
              loading="lazy"
              role="presentation"
              decoding="async"
              fetchpriority="high"
                src="https://cdn.shopify.com/s/files/1/0066/4574/3686/files/Abstract_LinkedIn_Background.png?v=1627912075"
                alt="Employer Background"
                className="img-fluid  w-100"
              />
              <div
                className="position-absolute top-50 translate-middle-y end-0 d-flex align-items-center justify-content-center"                
              >
                <img
                loading="lazy"
                role="presentation"
                decoding="async"
                fetchpriority="high"
                  src={employerData.company_logo ? `${process.env.REACT_APP_API_URL}${employerData.company_logo}` : logo}
                  alt="Employer Logo"
                  className="img-fluid bg-white border-1 border-white rounded-circle shadow p-2 mx-5"
                  style={{ width: "150px", height: "150px", objectFit: "fill" }}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = logo;
                  }}
                />
              </div>
            </div>
              <div className="card-body mt-2">
                <div className="d-flex justify-content-between align-items-start">
                  <div>
                    <h4 className="mb-2">{employerData.company_name}</h4>
                    <p className="text-secondary mb-1">
                      <i className="fa-solid fa-industry me-2"></i>
                      {employerData.primary_industry}
                    </p>
                    <p className="text-secondary mb-1">
                      <i className="fa-solid fa-clock me-2"></i>
                      Since {employerData.established_in}
                    </p>
                    <p className="text-secondary mb-3">
                      <i className="fa-solid fa-location-dot me-2"></i>
                      {employerData.address}, {employerData.city_name}, {employerData.state_name || "N/A"}, {employerData.country_name}, {employerData.post_code}
                    </p>
                  </div>
                </div>
                <hr />
                <div className="mt-4">
                  <h5>About Company</h5>
                  <p className="text-secondary">{employerData.about_company}</p>
                </div>
              </div>
            </div>
            <hr />
            <div className="container">
      <h4 className="mb-4">Available jobs</h4>
<div className="row justify-content-center">
                {loading ? ( 
                  <div className="text-center">
                    <img src={loader} alt="Loading..." style={{ width: "80px" }} />
                  </div>
                ) : jobs.length > 0 ? (
                  jobs.map((job) => (
                    <JobCard key={job.job_id} job={job} isInWishlist={isInWishlist} />
                  ))
                ) : (
                  <p className="text-center text-muted">No jobs available for this employer.</p> 
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EmployerDetails;